import { render } from "./intelligence-sparkle.svg.js?vue&type=template&id=784f7d46!=!../../../../node_modules/rspack-vue-loader/dist/index.js??clonedRuleSet-12.use[0]!../../../../node_modules/vue-svg-loader-2/index.js??clonedRuleSet-12.use[1]!./intelligence-sparkle.svg?vue&type=template&id=784f7d46"
const script = {}

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__